import { render, staticRenderFns } from "./DynamicComponent.vue?vue&type=template&id=63f6850b&scoped=true"
import script from "./DynamicComponent.vue?vue&type=script&lang=js"
export * from "./DynamicComponent.vue?vue&type=script&lang=js"
import style0 from "./DynamicComponent.vue?vue&type=style&index=0&id=63f6850b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6850b",
  null
  
)

export default component.exports